<template>
  <div class="row row-cols-1 gy-3">
    <div class="col">
      <input
        type="text"
        class="form-control form-control-lg"
        placeholder="入力してください。"
        id="inputValue"
      />
      <button class="btn btn-lg btn-success w-100 py-4 mt-2">
        <i class="bi bi-check-circle-fill me-2"></i> 入力しました
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InspectionComparison',
}
</script>
